import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const slot = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  height: ${spacing(8)};

  :first-child {
    border-top-left-radius: ${spacing(2)};
    border-top-right-radius: ${spacing(2)};
  }

  :last-child {
    border-bottom-left-radius: ${spacing(2)};
    border-bottom-right-radius: ${spacing(2)};
  }
`
export const cargoType = css`
  min-inline-size: ${spacing(38)};
`
export const counterClasses = {
  root: css`
    min-inline-size: ${spacing(14)};
  `,
}
